module.exports = __webpack_public_path__ + "28c02a568fe701b89538b85ca4b6ecbf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/snowboard-s.png
// module id = 2447
// module chunks = 0